module.exports = __webpack_public_path__ + "static/media/shopify8.198545c1.png";